import type { WorldDiagnostics } from './types';

export class WorldDiagnosticsBuilder {
  private readonly missingTiles = new Set<string>();
  private readonly invalidRoads = new Set<string>();
  private readonly invalidWater = new Set<string>();
  private readonly blockedPlots = new Set<string>();
  private readonly performanceWarnings = new Set<string>();
  private readonly notes = new Set<string>();

  addMissingTile(message: string): void {
    this.missingTiles.add(message);
  }

  addInvalidRoad(message: string): void {
    this.invalidRoads.add(message);
  }

  addInvalidWater(message: string): void {
    this.invalidWater.add(message);
  }

  addBlockedPlot(message: string): void {
    this.blockedPlots.add(message);
  }

  addPerformanceWarning(message: string): void {
    this.performanceWarnings.add(message);
  }

  addNote(message: string): void {
    this.notes.add(message);
  }

  toJSON(): WorldDiagnostics {
    return {
      missingTiles: [...this.missingTiles],
      invalidRoads: [...this.invalidRoads],
      invalidWater: [...this.invalidWater],
      blockedPlots: [...this.blockedPlots],
      performanceWarnings: [...this.performanceWarnings],
      notes: [...this.notes],
    };
  }
}
